"use client"

export type NpColorValue = { color: string; image?: undefined } | { color?: undefined; image: string }

export type NpColorProps = {
  values: NpColorValue[]
}

export const NpColor = ({ values }: NpColorProps) => {
  return (
    <div className="flex size-9 flex-col overflow-hidden rounded-full shadow transition-opacity group-active:opacity-50">
      {values.map((color, index) => {
        return (
          <div
            key={index}
            className="w-full flex-1"
            style={{
              backgroundImage: color.image ? `url(${color.image})` : undefined,
              backgroundColor: color.color || "#fff",
            }}
          />
        )
      })}
    </div>
  )
}
